import { render, staticRenderFns } from "./CalcMethodCards.vue?vue&type=template&id=2d5375ac&"
import script from "./CalcMethodCards.vue?vue&type=script&lang=js&"
export * from "./CalcMethodCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports